import { render, staticRenderFns } from "./open_order_indicator.vue?vue&type=template&id=f432c90c&"
import script from "./open_order_indicator.vue?vue&type=script&lang=coffee&"
export * from "./open_order_indicator.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports